module.exports = __webpack_public_path__ + "build/img/COMPANY.340985b4.svg";